import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { FormatHelper } from '../../../helpers/FormatHelper';
import { RecipeNotificationResultType } from '../../../enums/RecipeNotificationResultType';
import { ContactType } from '../../../enums/ContactType';
import { RecipeCollectionNotification } from '../../../models/RecipeCollectionNotification';
import { If } from '../../../common-components/If/If';
import {
  CardContainer, MainInformation, NotificationFieldGroup, NotificationFieldTitle,
  NotificationFieldValue, ResultDescription, ResultDetails
} from './styles';

interface ICardNotificationProps {
  recipeNotification?: RecipeCollectionNotification;
}

export const CardNotificationV2: React.FC<ICardNotificationProps> = ({
  recipeNotification
}) => {

  let resultTypeDescription = 'A notificação ainda não foi enviada.';
  switch (recipeNotification?.resultType) {
    case RecipeNotificationResultType.Success:
      resultTypeDescription = 'A notificação foi enviada com sucesso.';
      break;
    case RecipeNotificationResultType.Failed:
      resultTypeDescription = 'A notificação falhou ao ser enviada.';
      break;
  }

  let contactTypeDescription = '';
  switch (recipeNotification?.contactType) {
    case ContactType.Sms:
      contactTypeDescription = 'SMS';
      break;
    case ContactType.WhatsApp:
      contactTypeDescription = 'WhatsApp';
      break;
    case ContactType.Slack:
      contactTypeDescription = 'Slack';
      break;
  }

  return (
    <CardContainer>
      <ResultDescription>{resultTypeDescription}</ResultDescription>
      <MainInformation>
        <NotificationFieldGroup>
          <NotificationFieldTitle>Para</NotificationFieldTitle>
          <NotificationFieldValue>
            <span>{recipeNotification?.contact}</span>
            {contactTypeDescription ? <Badge pill bg="secondary" style={{marginLeft:'5px'}}>{contactTypeDescription}</Badge> : null}
          </NotificationFieldValue>
        </NotificationFieldGroup>
        <NotificationFieldGroup alignItems='flex-end'>
          <NotificationFieldTitle>Data</NotificationFieldTitle>
          <NotificationFieldValue>{FormatHelper.formatDateTime(recipeNotification?.notifiedAt)}</NotificationFieldValue>
        </NotificationFieldGroup>
      </MainInformation>
      <If condition={recipeNotification?.resultDetails !== undefined}>
        <ResultDetails>
          <NotificationFieldTitle>Detalhes</NotificationFieldTitle>
          <NotificationFieldValue>{recipeNotification?.resultDetails}</NotificationFieldValue>
        </ResultDetails>
      </If>
    </CardContainer>
  );
}